// UPost - Frontend Configuration

// Use the backend URL from environment variable, with fallback to window.location.origin
// In development, this uses the external preview URL for proper API routing
export const API_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : '');

export const FREE_TIER_AI_WORDS = 18400;
export const PRO_TIER_AI_WORDS = 999999999;

export const SUBSCRIPTION_PRICES = {
  pro_monthly: 29.00,
  pro_yearly: 290.00,
  premium_monthly: 69.00,
  premium_yearly: 690.00,
  team_monthly: 34.95,
  team_yearly: 349.00,
  admin_monthly: 59.95,
  admin_yearly: 599.00,
  additional_seat: 2.99,
  copyright_blockchain: 9.99,
  power_credits_small: 15.00,
  power_credits_medium: 40.00,
  power_credits_large: 90.00
};

export const DOCUMENT_TYPES = [
  { value: 'novel', label: 'Novel', icon: '📚' },
  { value: 'screenplay', label: 'Screenplay', icon: '🎬' },
  { value: 'script', label: 'Script', icon: '📝' }
];

export const AI_OPERATIONS = [
  { value: 'continue', label: 'Continue Writing', description: 'AI extends from cursor' },
  { value: 'rewrite', label: 'Rewrite/Improve', description: 'Enhance selected text' },
  { value: 'ideas', label: 'Generate Ideas', description: 'Plot, characters, scenes' },
  { value: 'dialogue', label: 'Polish Dialogue', description: 'Make conversations natural' },
  { value: 'expand', label: 'Expand Scene', description: 'Turn notes into full scenes' },
  { value: 'tone_adjust', label: 'Adjust Tone', description: 'Change mood/style' }
];

export const TONES = [
  'lighthearted',
  'dark',
  'dramatic',
  'humorous',
  'suspenseful',
  'romantic'
];